import { apis } from "apis";
import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import { ServiceInjectable } from "src/utils/services";

/**
 * 角色类
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class RoleService extends ServiceBase
{
    /**
     * 新增角色
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async addRole(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.addRole({ data });
        return response;
    }
    
    /**
     * 删除角色
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async deleteRole(id: number): Promise<IHttpResponse>
    {
        let response = await this.apis.deleteRole({ urlPath: { id } });
        return response;
    }
 
    /**
     * 编辑角色
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async editRole(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.editRole({ data });
        return response;
    }

    /**
     * 获取角色分页数据
     * @param id 用户id
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getRolePage(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.getRolePage({ 
            data: data
        });
        return response;
    }

    /**
     * 获取角色列表
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getRoleList(id?: number): Promise<IHttpResponse>
    {
        let response;
        if(id)
        {
            response = await this.apis.getRoleList({params:{orgId:id}});
        }
        else
        {
            response = await this.apis.getRoleList();
        }

        return response;
    }

    /**
     * 此角色已有菜单权限
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getRoleOwnMenu(id: number): Promise<IHttpResponse>
    {
        let response = await this.apis.getRoleOwnMenu({ params: { id } });
        return response;
    }

    /**
     * 角色授权菜单
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async roleGrantMenu(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.roleGrantMenu({ data: data });
        return response;
    }

     /**
     * 此角色已有数据权限
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getRoleOwnData(id: number): Promise<IHttpResponse>
    {
        let response = await this.apis.getRoleOwnData({ params: { id } });
        return response;
    }

    /**
     * 角色授权数据
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async roleGrantData(data: any): Promise<IHttpResponse>
     {
         let response = await this.apis.roleGrantData({ data: data });
         return response;
     }
}
